import { Navigate, Route, Routes } from 'react-router-dom';
import { PageTitle } from '../../../_start/layout/core';
import { CallRatesPage } from './pages/call-rate/CallRatesPage';
import { UpdateCallRate } from './pages/call-rate/UpdateCallRate';
import { CategoriesPage } from './pages/category/CategoriesPage';
import { CreateCategory } from './pages/category/CreateCategory';
import { UpdateCategory } from './pages/category/UpdateCategory';
import { CreateFAQ } from './pages/faq/CreateFAQ';
import { FAQsPage } from './pages/faq/FAQsPage';
import { UpdateFAQ } from './pages/faq/UpdateFAQ';
import { CreatePackageType } from './pages/package-type/CreatePackageType';
import { PackageTypesPage } from './pages/package-type/PackageTypesPage';
import { UpdatePackageType } from './pages/package-type/UpdatePackageType';
import { CreatePackage } from './pages/package/CreatePackage';
import { PackagesPage } from './pages/package/PackagesPage';
import { UpdatePackage } from './pages/package/UpdatePackage';
import { CreateProduct } from './pages/product/CreateProduct';
import { ProductsPage } from './pages/product/ProductsPage';
import { UpdateProduct } from './pages/product/UpdateProduct';

export const ContentManagementPage = () => {
  return (
    <Routes>
      {/* PACKAGES */}
      <Route
        path="packages"
        element={
          <>
            <PageTitle>Pakketten</PageTitle>
            <PackagesPage />
          </>
        }
      />
      <Route
        path="packages/create"
        element={
          <>
            <PageTitle>Pakketten</PageTitle>
            <CreatePackage />
          </>
        }
      />
      <Route
        path="packages/:id/update"
        element={
          <>
            <PageTitle>Pakketten</PageTitle>
            <UpdatePackage />
          </>
        }
      />
      {/* PACKAGES */}

      {/* PACKAGE TYPES */}
      <Route
        path="package-types"
        element={
          <>
            <PageTitle>Pakkettype</PageTitle>
            <PackageTypesPage />
          </>
        }
      />
      <Route
        path="package-types/create"
        element={
          <>
            <PageTitle>Pakkettype</PageTitle>
            <CreatePackageType />
          </>
        }
      />
      <Route
        path="package-types/:id/update"
        element={
          <>
            <PageTitle>Pakkettype</PageTitle>
            <UpdatePackageType />
          </>
        }
      />
      {/* PACKAGES */}

      {/* PRODUCTS */}
      <Route
        path="products"
        element={
          <>
            <PageTitle>Producten</PageTitle>
            <ProductsPage />
          </>
        }
      />
      <Route
        path="products/create"
        element={
          <>
            <PageTitle>Producten</PageTitle>
            <CreateProduct />
          </>
        }
      />
      <Route
        path="products/:id/update"
        element={
          <>
            <PageTitle>Producten</PageTitle>
            <UpdateProduct />
          </>
        }
      />
      {/* PRODUCTS */}

      {/* CATEGORIES */}
      <Route
        path="categories"
        element={
          <>
            <PageTitle>Categorieën</PageTitle>
            <CategoriesPage />
          </>
        }
      />
      <Route
        path="categories/create"
        element={
          <>
            <PageTitle>Categorieën</PageTitle>
            <CreateCategory />
          </>
        }
      />
      <Route
        path="categories/:id/update"
        element={
          <>
            <PageTitle>Categorieën</PageTitle>
            <UpdateCategory />
          </>
        }
      />
      {/* CATEGORIES */}

      {/* CALL RATES */}
      <Route
        path="call-rates"
        element={
          <>
            <PageTitle>Beltarieven</PageTitle>
            <CallRatesPage />
          </>
        }
      />

      <Route
        path="call-rates/:id/update"
        element={
          <>
            <PageTitle>Beltarieven</PageTitle>
            <UpdateCallRate />
          </>
        }
      />

      {/* CALL RATES */}

      {/* FAQs */}
      <Route
        path="faqs"
        element={
          <>
            <PageTitle>FAQs</PageTitle>
            <FAQsPage />
          </>
        }
      />
      <Route
        path="faqs/create"
        element={
          <>
            <PageTitle>FAQs</PageTitle>
            <CreateFAQ />
          </>
        }
      />
      <Route
        path="faqs/:id/update"
        element={
          <>
            <PageTitle>FAQs</PageTitle>
            <UpdateFAQ />
          </>
        }
      />
      {/* FAQs */}

      <Route
        index
        element={<Navigate to="/content-management/categories" replace />}
      />
      <Route
        path="*"
        element={<Navigate to="/content-management/categories" replace />}
      />
    </Routes>
  );
};
